import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Splash from './pages/Splash';
import AccountTypeSelector from './components/auth/AccountTypeSelector';
import AthleteRegistration from './components/auth/AthleteRegistration';
import CoachRegistration from './components/auth/CoachRegistration';
import AthleteOnboardingV2 from './components/onboarding/AthleteOnboardingV2';
import Login from './pages/auth/Login';
import Dashboard from './pages/dashboard/DashboardPage';
import ProgressiveDashboard from './pages/dashboard/ProgressiveDashboard';
import OnboardingSuccess from './pages/onboarding/OnboardingSuccess';
import PrivateRoute from './components/PrivateRoute';
import CoachOnboarding from './components/coach/CoachOnboarding';


function App() {
  return (
    <Router>
      <Routes>
        {/* Public routes */}
        <Route path="/register" element={<AccountTypeSelector />} />
        <Route path="/register/athlete" element={<AthleteRegistration />} />
        <Route path="/register/coach" element={<CoachRegistration />} />
        <Route path="/login" element={<Login />} />
        
        {/* Protected routes */}
        <Route
          path="/onboarding/athlete"
          element={
            <PrivateRoute>
              <AthleteOnboardingV2 />
            </PrivateRoute>
          }
        />
        <Route
          path="/onboarding/coach"
          element={
            <PrivateRoute>
              <CoachOnboarding />
            </PrivateRoute>
          }
        />
        <Route
          path="/onboarding/success"
          element={
            <PrivateRoute>
              <OnboardingSuccess />
            </PrivateRoute>
          }
        />
        <Route
          path="/dashboard"
          element={
            <PrivateRoute>
              <ProgressiveDashboard />
            </PrivateRoute>
          }
        />
        
        {/* Default route - Splash screen */}
        <Route path="/" element={<Splash />} />
      </Routes>
    </Router>
  );
}

export default App;